export function showMessage(message = 'Something went wrong', message_tags) {
    const event = new Event('localStorageChange');
    event.value = {
        message_tags,
        message,
    };
    window.dispatchEvent(event);
}
